define('adminPhrasesListHeaderToolsView',[
  'app',
  'module',
  'underscore',
  'windows',
  'adminPhrasesCreateEditView',
  'tableHeaderFieldView',
  'template!adminPhrasesListHeaderToolsView',
  'entities/phrases'
], function (
  App,
  Module,
  _,
  Windows,
  CreateEditView,
  FieldView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-phrases-list-header-tools-view table-field-view',

    ui: {
      addButton: '.add'
    },

    events: {
      'click @ui.addButton': 'onAdd'
    },

    onAdd: function () {
      var createEditView = new CreateEditView({
        phraseModel: App.request('phrases:model'),
        newItem: true
      });
      createEditView.show({
        title: _.i18n('phrases.new')
      });
      createEditView.listenTo(createEditView, 'saved', _.bind(function () {
        this.tableView.bodyView.fetch();
        this.tableView.footerView.fetch();
      }, this));
    }
  });
});

